// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"488":"2800238b","577":"bdfb5b11","709":"b97bc7da","826":"adef257d"}[chunkId] + ".css";
};